/* GMU add to cart + card quick add + colour dots (T14).
   window.gmuCartAdd(body, isJson, onAdded): POST /cart/add.js with the drawer's sections, then re-render + open the existing
   <cart-drawer> (same API as the theme's product-form.js); used by gmu-product.js (PDP) and the card quick add.
   onAdded (optional) runs after a successful add; the drawer then opens after a short pause (tick feedback).
   Card quick add (snippets/gmu-product-card.liquid): a slim size row replaces the colour line on hover / focus (desktop, CSS).
   Phones / touch (T20): the "+" on the photo opens ONE shared bottom sheet (.gmu-qs) filled from the card's current
   (possibly colour-swapped) name / colour / price / photo and its size buttons; backdrop / X / Esc / swipe down closes.
   Colour dots (snippets/gmu-siblings.liquid): swap THIS card to the sibling from the dot's data; sizes come from
   /products/<handle>.js on first use (cached). */
(function () {
  if (window.gmuCartAdd) return;

  window.gmuCartAdd = function (body, isJson, onAdded) {
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var opts = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } };
    if (isJson) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    } else {
      if (sections.length) { body.append('sections', sections.join(',')); body.append('sections_url', window.location.pathname); }
      opts.body = body;
    }
    return fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', opts)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Error');
        if (typeof onAdded === 'function') onAdded(res);
        return new Promise(function (ok) { setTimeout(function () { ok(res); }, onAdded ? 450 : 0); });
      })
      .then(function (res) {
        if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gmu', cartData: res }); } catch (e) {}
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
        return res;
      });
  };

  var touch = window.matchMedia('(hover:none), (pointer:coarse)');
  function str(k, d) { return (window.gmuStrings && gmuStrings[k]) || d; }

  /* ---- bottom sheet (T20) ---- */
  var qs = null, qsCard = null, qsBack = null, qsTimer = 0, qsOpenedAt = 0;
  /* G3: cards with a sheet add running (lock per card, so another card's sheet is not blocked) */
  var busyCards = typeof WeakSet === 'function' ? new WeakSet() : null;
  function sheetEl() {
    if (qs) return qs;
    qs = document.createElement('div');
    qs.className = 'gmu gmu-qs';
    qs.hidden = true;
    qs.innerHTML =
      '<div class="gmu-qs__dim" data-qs-close></div>' +
      '<div class="gmu-qs__sheet" role="dialog" aria-modal="true" tabindex="-1">' +
        '<div class="gmu-qs__grab" aria-hidden="true"></div>' +
        '<button type="button" class="gmu-qs__x" data-qs-close aria-label="' + esc(str('close', 'Close')) + '">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="gmu-qs__hd"><img class="gmu-qs__th" alt="" data-qs-th><div><b class="gmu-qs__name" data-qs-name></b><span class="gmu-qs__line" data-qs-line></span></div></div>' +
        '<p class="gmu-qs__lbl"><span>' + esc(str('selectSize', 'Select size')) + '</span><a href="' + esc(str('fitUrl', '/pages/fit-guide')) + '">' + esc(str('sizeGuide', 'Size guide')) + '</a></p>' +
        '<div class="gmu-qs__sizes" data-qs-sizes></div>' +
        '<p class="gmu-qs__msg" role="status" aria-live="polite" data-qs-msg></p>' +
      '</div>';
    document.body.appendChild(qs);
    swipe(qs.querySelector('.gmu-qs__sheet'));
    return qs;
  }
  function syncSheet(card) {
    if (!qs || qsCard !== card) return;
    var box = card.querySelector('[data-qa-sizes]');
    qs.querySelector('[data-qs-sizes]').innerHTML = box ? box.innerHTML : '';
  }
  function openSheet(card, plus) {
    var el = sheetEl();
    clearTimeout(qsTimer);
    qsCard = card; qsBack = plus;
    var dlg = el.querySelector('[role="dialog"]');
    dlg.setAttribute('aria-label', plus.getAttribute('aria-label') || '');
    var name = card.querySelector('[data-card-name]');
    var col = card.querySelector('[data-card-colour]');
    var price = card.querySelector('[data-card-price]');
    var front = card.querySelector('.gmu-card__front');
    el.querySelector('[data-qs-name]').textContent = name ? name.textContent : '';
    el.querySelector('[data-qs-line]').innerHTML = (col && !col.hidden && col.textContent.trim() ? esc(col.textContent.trim()) + ' · ' : '') + (price ? price.innerHTML : '');
    var th = el.querySelector('[data-qs-th]');
    th.hidden = !front;
    if (front) th.src = front.currentSrc || front.src;
    el.querySelector('[data-qs-msg]').textContent = '';
    syncSheet(card);
    ensureSizes(card);
    el.hidden = false;
    qsOpenedAt = Date.now();
    void el.offsetWidth; /* start the slide from the closed position */
    el.classList.add('is-on');
    document.documentElement.classList.add('gmu-qs-lock');
    plus.setAttribute('aria-expanded', 'true');
    var first = el.querySelector('[data-qs-sizes] [data-qa-id]:not([disabled])');
    (first || dlg).focus({ preventScroll: true });
  }
  function closeSheet(restore) {
    if (!qs || qs.hidden) return;
    var dlg = qs.querySelector('.gmu-qs__sheet');
    qs.classList.remove('is-on');
    dlg.style.transform = '';
    document.documentElement.classList.remove('gmu-qs-lock');
    if (qsBack) qsBack.setAttribute('aria-expanded', 'false');
    if (restore && qsBack) qsBack.focus({ preventScroll: true });
    qsCard = null;
    qsTimer = setTimeout(function () { qs.hidden = true; }, 260);
  }
  function sheetOpen() { return !!(qs && !qs.hidden && qs.classList.contains('is-on')); }
  function swipe(dlg) {
    var y0 = null, dy = 0;
    dlg.addEventListener('touchstart', function (e) {
      y0 = dlg.scrollTop <= 0 ? e.touches[0].clientY : null; dy = 0;
    }, { passive: true });
    dlg.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = e.touches[0].clientY - y0;
      if (dy > 0) { dlg.style.transition = 'none'; dlg.style.transform = 'translateY(' + dy + 'px)'; }
    }, { passive: true });
    function end(e) {
      if (y0 === null) return;
      dlg.style.transition = '';
      /* touchcancel (system gesture, scroll takeover): snap back, never close */
      if (e.type === 'touchend' && dy > 70) closeSheet(true); else dlg.style.transform = '';
      y0 = null;
    }
    dlg.addEventListener('touchend', end);
    dlg.addEventListener('touchcancel', end);
  }

  function addFrom(btn) {
    var inSheet = !!btn.closest('.gmu-qs');
    var card = inSheet ? qsCard : btn.closest('[data-gmu-card]');
    /* the sheet may be closed or reopened on another card while this add runs: only touch it if it still shows this card */
    var forCard = card;
    function mine() { return !inSheet || qsCard === forCard; }
    if (inSheet && busyCards && forCard) busyCards.add(forCard);
    var msg = inSheet ? qs.querySelector('[data-qs-msg]') : card && card.querySelector('[data-qa-msg]');
    if (msg) msg.textContent = '';
    var drawer = document.querySelector('cart-drawer');
    /* focus returns here when the drawer closes: the "+" (sheet), the photo link on desktop */
    var back = inSheet ? qsBack : card && card.querySelector('.gmu-card__media');
    if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(back || btn);
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    window.gmuCartAdd({ items: [{ id: Number(btn.dataset.qaId), quantity: 1 }] }, true, function () {
      btn.removeAttribute('aria-busy');
      btn.classList.add('is-done');
      if (!inSheet) btn.textContent = '✓';
    })
      .then(function () { if (inSheet && mine()) closeSheet(false); })
      .catch(function (err) { if (msg && mine()) msg.textContent = err.message; })
      .finally(function () {
        if (inSheet && busyCards && forCard) busyCards.delete(forCard);
        btn.removeAttribute('aria-busy');
        setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 600);
      });
  }

  function closePops(keep) {
    document.querySelectorAll('.gmu-card.qa-open').forEach(function (c) {
      if (c === keep) return;
      c.classList.remove('qa-open');
      var t = c.querySelector('[data-qa-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('mouseleave', function (e) {
    var c = e.target && e.target.classList && e.target.classList.contains('qa-open') ? e.target : null;
    if (c) closePops(null);
  }, true);

  document.addEventListener('click', function (e) {
    /* G2: a fast double tap on "+" lands its 2nd tap inside the fresh sheet (backdrop or a size): ignore it */
    if (qs && qs.contains(e.target) && Date.now() - qsOpenedAt < 350) return;
    var tog = e.target.closest('[data-qa-toggle]');
    if (tog) {
      var card = tog.closest('[data-gmu-card]');
      if (!card || card.classList.contains('is-soldout')) return;
      /* 7 Oct (Vilo): desktop "+" opens a small size picker on the photo; phones / touch keep the bottom sheet */
      if (window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:761px)').matches) {
        var on = !card.classList.contains('qa-open');
        closePops(card);
        card.classList.toggle('qa-open', on);
        tog.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (on) { var f1 = card.querySelector('.gmu-qa [data-qa-id]:not([disabled]):not(.is-out)'); if (f1) f1.focus({ preventScroll: true }); }
      } else openSheet(card, tog);
      return;
    }
    if (!e.target.closest('.gmu-qa')) closePops(null);
    var cl = e.target.closest('[data-qs-close]');
    if (cl) {
      closeSheet(true); return;
    }
    var btn = e.target.closest('[data-qa-id]');
    if (btn) {
      if (btn.closest('.gmu-qs') && busyCards && busyCards.has(qsCard)) return; /* one sheet add at a time per card */
      if (!btn.disabled) addFrom(btn);
      return;
    }
    var dot = e.target.closest('[data-sw]');
    if (dot) { e.preventDefault(); swap(dot); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (sheetOpen()) {
      if (e.key === 'Escape') { e.preventDefault(); closeSheet(true); return; }
      if (e.key === 'Tab') {
        /* focus trap */
        var f = Array.prototype.filter.call(qs.querySelectorAll('button:not([disabled]), a[href]'), function (x) { return x.offsetParent; });
        if (!f.length) { e.preventDefault(); return; }
        var i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
      }
      return;
    }
    if (e.key === 'Escape') {
      var card = e.target.closest && e.target.closest('[data-gmu-card]');
      if (card && card.classList.contains('qa-open')) { closePops(null); var tg = card.querySelector('[data-qa-toggle]'); if (tg) tg.focus(); return; }
      if (card && e.target.closest('[data-qa]')) {
        /* desktop: the row shows on hover/focus-within, so hide it until the pointer or focus leaves the card */
        card.classList.add('qa-off');
        var back = card.querySelector('.gmu-card__media');
        if (back) back.focus();
      }
    }
    var d = e.target.closest && e.target.closest('[data-sw]');
    if (d && e.key === ' ') { e.preventDefault(); swap(d); }
  });
  document.addEventListener('focusin', function (e) {
    /* keep focus inside the open sheet (the cart drawer may take it once the add is done) */
    if (sheetOpen() && !qs.contains(e.target) && !e.target.closest('cart-drawer')) {
      var dlg = qs.querySelector('.gmu-qs__sheet');
      dlg.focus({ preventScroll: true });
    }
  });

  function qaOn(e) {
    var card = e.target.closest && e.target.closest('.gmu-card.qa-off');
    if (card && !(e.relatedTarget && card.contains(e.relatedTarget))) card.classList.remove('qa-off');
  }
  document.addEventListener('focusout', qaOn);
  document.addEventListener('mouseout', qaOn);

  /* ---- colour dots ---- */
  var cache = {};
  function sizeIdx(opts, words) {
    for (var i = 0; i < opts.length; i++) {
      var n = String(opts[i].name || opts[i]).toLowerCase();
      for (var w = 0; w < words.length; w++) if (n.indexOf(words[w]) > -1) return i;
    }
    return -1;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function buildSizes(p) {
    var si = sizeIdx(p.options, ['size', 'größe', 'grösse', 'maat', 'waist', 'taille']);
    var ci = sizeIdx(p.options, ['colo', 'farbe', 'kleur']);
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    if (p.variants.length === 1) {
      var lbl = (window.gmuStrings && gmuStrings.add) || 'Add to cart';
      return '<button type="button" class="gmu-qa__one" data-qa-id="' + first.id + '"' + (first.available ? '' : ' disabled') + '>' + esc(lbl) + '</button>';
    }
    return p.variants.filter(function (v) { return ci < 0 || v.options[ci] === first.options[ci]; }).map(function (v) {
      var l = si > -1 ? v.options[si] : v.title;
      return v.available
        ? '<button type="button" class="gmu-qa__size" data-qa-id="' + v.id + '">' + esc(l) + '</button>'
        : '<button type="button" class="gmu-qa__size is-out" disabled aria-label="' + esc(l) + '">' + esc(l) + '</button>';
    }).join('');
  }
  function loadSizes(card, handle) {
    var box = card.querySelector('[data-qa-sizes]');
    if (!box || !handle) return;
    box.dataset.handle = handle;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'products/' + encodeURIComponent(handle);
    var p = cache[handle] || (cache[handle] = fetch(url + '.js').then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }));
    p.then(function (prod) { if (box.dataset.handle === handle) { box.innerHTML = buildSizes(prod); syncSheet(card); } }).catch(function () {
      /* failed lookup: not cached, so the next open retries; meanwhile the row links to the product page */
      delete cache[handle];
      if (box.dataset.handle !== handle) return;
      box.dataset.pending = handle;
      var lbl = (window.gmuStrings && gmuStrings.view) || 'View product';
      box.innerHTML = '<a class="gmu-qa__one" href="' + esc(url) + '">' + esc(lbl) + '</a>';
      syncSheet(card);
    });
  }
  function ensureSizes(card) {
    var box = card.querySelector('[data-qa-sizes]');
    if (box && box.dataset.pending) { var h = box.dataset.pending; delete box.dataset.pending; loadSizes(card, h); }
  }
  function swap(dot) {
    var card = dot.closest('[data-gmu-card]');
    if (!card || dot.classList.contains('is-on')) return;
    var d = dot.dataset;
    var media = card.querySelector('.gmu-card__media');
    if (media) {
      media.href = d.swUrl;
      media.setAttribute('aria-label', d.swAlt);
      var f = media.querySelector('.gmu-card__front');
      if (f && d.swImg) { f.removeAttribute('srcset'); f.src = d.swImg; f.alt = d.swAlt; }
      var a = media.querySelector('.gmu-card__alt');
      if (a && d.swImg2) { a.removeAttribute('srcset'); a.src = d.swImg2; }
      else if (a) { a.removeAttribute('srcset'); a.src = d.swImg; }
    }
    var name = card.querySelector('[data-card-name]');
    if (name) { name.textContent = d.swName; name.href = d.swUrl; }
    var price = card.querySelector('[data-card-price]');
    if (price) price.innerHTML = d.swPrice;
    var col = card.querySelector('[data-card-colour]');
    if (col) { col.textContent = d.swColour; col.hidden = !d.swColour; }
    card.classList.toggle('is-soldout', d.swAvail !== 'true');
    /* T26: the heart follows the shown colour (not on the favourites page, where it stays on the saved item: data-fav-pin) */
    var fav = card.querySelector('[data-fav]');
    if (fav && d.swHandle && !fav.hasAttribute('data-fav-pin')) { fav.setAttribute('data-fav', d.swHandle); if (window.gmuFav) gmuFav.sync(fav); }
    var box = card.querySelector('[data-qa-sizes]');
    if (box) {
      box.innerHTML = '';
      /* fetch now if the row can be seen (hover / focus), else on the next open */
      if (card.matches(':hover') || card.contains(document.activeElement)) loadSizes(card, d.swHandle);
      else box.dataset.pending = d.swHandle;
    }
    card.querySelectorAll('[data-sw]').forEach(function (x) {
      var on = x === dot;
      x.classList.toggle('is-on', on);
      x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('mouseover', function (e) {
    if (touch.matches) return;
    var dot = e.target.closest && e.target.closest('[data-sw]');
    if (dot) { swap(dot); return; }
    var card = e.target.closest && e.target.closest('[data-gmu-card]');
    if (card && entered(card, e)) ensureSizes(card);
  });
  document.addEventListener('focusin', function (e) {
    var card = e.target.closest && e.target.closest('[data-gmu-card]');
    if (card && entered(card, e)) ensureSizes(card);
  });
  /* pending sizes (swap or failed lookup) load when pointer / focus ENTERS the card, not on every move between its children */
  function entered(card, e) { return !(e.relatedTarget && card.contains(e.relatedTarget)); }

  /* Theme Recently viewed section: centre its (restyled) swiper arrows on the product image, like gmu-carousel. */
  function rvMid() {
    document.querySelectorAll('recently-viewed-products .swiper').forEach(function (sw) {
      var img = sw.querySelector('li img');
      if (!img || !img.offsetHeight) return;
      var a = sw.getBoundingClientRect(), b = img.getBoundingClientRect();
      sw.style.setProperty('--gmu-rv-mid', Math.round(b.top - a.top + b.height / 2) + 'px');
    });
  }
  var rvTries = 0, rvTimer = setInterval(function () { rvMid(); if (++rvTries > 20) clearInterval(rvTimer); }, 500);
  window.addEventListener('resize', rvMid);
})();

/* 7 Oct: Recently viewed row, shared by the product page (gmu-product.js) and the gmu-recently-viewed section (collections).
   Ids from localStorage "_halo_recently_viewed" (newest first, the current product left out), cards rendered by the gmu-product
   section through /search?section_id=gmu-product&q=id:.. (same cards as You may also like), then put back in viewed order. */
window.gmuRecent = function (sec, excludeId, watchEl) {
  if (!sec || !sec.dataset.rvUrl) return;
  var ids = [];
  try { ids = JSON.parse(localStorage.getItem('_halo_recently_viewed') || '[]'); } catch (e) {}
  ids = ids.filter(function (x) { return x && x !== excludeId; }).slice(0, 8);
  if (!ids.length) return;
  var url = sec.dataset.rvUrl + encodeURIComponent(ids.map(function (x) { return 'id:' + x; }).join(' OR '));
  var go = function () {
    fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var frag = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gmu-recs]');
      if (!frag || !frag.querySelector('.gmu-card')) return;
      frag.querySelectorAll('script').forEach(function (x) { x.remove(); });
      var tgt = sec.querySelector('[data-rv-target]');
      tgt.innerHTML = frag.innerHTML;
      var first = tgt.querySelector('.gmu-card'), track = first && first.parentElement;
      var items = track ? Array.prototype.slice.call(track.children) : [];
      var pos = function (el) { var c = el.querySelector('[data-product-id]') || el; var k = ids.indexOf(parseInt(c.getAttribute('data-product-id'), 10)); return k < 0 ? 99 : k; };
      if (items.length > 1 && items.every(function (el) { return pos(el) < 99; })) items.sort(function (a, b) { return pos(a) - pos(b); }).forEach(function (el) { track.appendChild(el); });
      if (window.gmuFav) window.gmuFav.syncAll();
      sec.hidden = false;
    }).catch(function () {});
  };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '600px 0px' });
    io.observe(watchEl || sec.parentElement || sec);
  } else go();
};
if (!customElements.get('gmu-recent')) customElements.define('gmu-recent', class extends HTMLElement {
  connectedCallback() { if (this._i) return; this._i = true; window.gmuRecent(this.querySelector('.gmu-pdp__rv'), parseInt(this.dataset.exclude, 10) || 0, this); }
});
